
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  ScatterChart,
  Scatter,
} from "recharts";
import './App.css';


let parseObj = null;

await fetch(`https://rakusen.ikura.tokyo/api/files/rr.json`)
  .then(res => res.json())
  .then(data => {
    parseObj = data;
  })
  .catch((e) => {
    const errorMsg = 'キャンペーン情報を取得できませんでした。例外情報=' + e.toString();
    console.error(errorMsg);
    return;
  })

// parseObj.chartData.forEach(a => a.at = new Date(a.at).getTime());
const oriItems = parseObj.items;

oriItems.forEach(i => i.ranks.forEach(r => r.at = new Date(r.at)))

const maxDate = oriItems.map(i => i.ranks[i.ranks.length - 1].at).reduce((maxDate, curDate) => {
  return curDate.getTime() < maxDate.getTime() ? maxDate : curDate;
});

oriItems.forEach(i => {
  const latestRank = i.ranks[i.ranks.length - 1];
  i.latestRank = (latestRank.at.getTime() === maxDate.getTime()) ? latestRank.rank : null
});

oriItems.sort((a, b) => (a.latestRank ? a.latestRank : 9999) - (b.latestRank ? b.latestRank : 9999));

// --- メインコンポーネント ---
const MinuteSeriesLineChart = () => {
  const searchInputRef = useRef(null);

  const [searchParams] = useSearchParams();

  const [search, setSearch] = useState('');
  const [beforeDay, setBeforeDay] = useState(0.5);

  useEffect(() => {
    const s = searchParams.get('s');
    if (s) {
      setSearch(s);
      searchInputRef.current.value = s;
    }
  }, []);

  let items = [];
  if (search) {
    search.split('\t').forEach(s => {
      const hit = oriItems.filter(i => (i.name + ' ' + i.url + ' ' + i.shop + i.priInfo).includes(s.trim()));
      items.push(...hit);
    });
    items = [...new Set(items)];
  } else {
    items.push(...oriItems);
  }


  items = items.slice(0, 10);

  console.table(items);

  const minDate = new Date(maxDate.getTime() - (beforeDay * 24 * 60 * 60 * 1000));
  console.log({ minDate, maxDate });

  const referenceLines = [];
  {
    let date = new Date(minDate);
    date.setHours(24, 0, 0, 0); // 翌日の 00:00 にセット
    while (date <= maxDate) {
      referenceLines.push(<ReferenceLine x={date.getTime()} stroke="gray" strokeWidth={0.5} />);
      date.setDate(date.getDate() + 1); // 1日進める
    }
  }

  return (
    <div>
      <h1>らくせん</h1>

      <form onSubmit={(event) => {
        event.preventDefault();

        if (searchInputRef.current) {
          setSearch(searchInputRef.current.value);
        }
      }}>

        <input
          type="text"
          ref={searchInputRef}
          placeholder="検索ワード"
          style={{ width: '50%' }}
        />
        <button type="submit">Search</button>
      </form>

      <div>
        <label>
          期間を選択：

          <select
            value={beforeDay}
            onChange={(e) => setBeforeDay(Number(e.target.value))}
          >
            {[0.5, 1, 2, 7, 30].map((day) => (
              <option key={day} value={day}> {day} 日 </option>
            ))}
          </select>
        </label>
      </div>

      {
        items.map(i =>
          <div key={i.url}>
            <div className="item">
              <div className="evenSplit">
                <div>

                  <ScatterChart
                    style={{
                      width: '98%',
                      height: '100%',
                      maxWidth: 800,
                      margin: 'auto'
                    }}
                    responsive
                  >
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />

                    <XAxis
                      dataKey="at"
                      type="number"
                      domain={[minDate.getTime(), maxDate.getTime()]}
                      allowDataOverflow={true}
                      tickFormatter={(timestamp) => {
                        const d = new Date(timestamp);
                        if (1 < beforeDay) {
                          return `${d.getMonth() + 1}/${d.getDate()}`;
                        } else {
                          return `${d.getHours()}:${d.getMinutes()}`;
                        }
                      }}
                    />
                    <YAxis
                      dataKey="rank"
                      width="auto"
                      reversed={true}
                      allowDataOverflow={true}
                      domain={[-20, 240]}
                      ticks={[1, 50, 100, 150, 200]}
                      tickFormatter={(value) => `${value}位`}
                    />

                    <Scatter
                      data={i.ranks}
                      shape={<circle r={5} />}
                      fill="#8884d8"
                      activeShape={{
                        stroke: '#fff', // 縁取りを白にする
                        strokeWidth: 2,
                        fill: '#ff7300'
                      }}
                    />

                    <Tooltip
                      formatter={(value, name, props) => {
                        switch (name) {
                          case 'rank':
                            return [value + ' 位'];
                          case 'at':
                            const date = value;
                            const dateStr = date.toLocaleDateString("ja-JP", {
                              month: "2-digit",
                              day: "2-digit",
                              weekday: "short",
                            });
                            const timeStr = date.toLocaleTimeString("ja-JP", {
                              hour: "2-digit",
                              minute: "2-digit",
                            });
                            return [`${dateStr} ${timeStr}`];
                          default:
                            return;
                        }
                      }}

                      cursor={{ strokeDasharray: '3 3' }}
                    />
                    {referenceLines}

                  </ScatterChart>
                </div>


                {
                  //             <img src={i.imgUrl} />
                }

                {
                  //style={{ backgroundImage: 'url("' + i.imgUrl + '")' }}
                }
                <div className="desc">
                  <div>{i.latestRank ? i.latestRank + '位' : '圏外'} </div>
                  <div>{i.name}</div>
                  <div>{i.priceInfo}</div>
                  <div>{i.shop}</div>
                  <div>
                    <a href={i.url} target="_blank" rel="noopener noreferrer" >商品ページへ</a>
                  </div>
                </div>

              </div>
            </div>
          </div>


        )
      }
    </div >
  );
};

export default MinuteSeriesLineChart;
